var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-container"},_vm._l((_vm.$store.state.notifications.toastNotifications),function(toast){return _c('toast',_vm._b({key:toast.id},'toast',toast,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }